import { SchedulesService } from '../../api';
import { QueryKeyFactoryGenerator } from '../../utils/query-keys-factory';

export const scheduleQueryKeys = new QueryKeyFactoryGenerator('schedule').getDefault<
  typeof SchedulesService.schedulesList,
  number
>();
